<template>
    <select
        :value="value"
        :disabled="disabled"
        :class="selectClasses"
        v-bind="$attrs"
        @change="onChange"
    >
        <template v-if="placeholder">
            <option value="" :disabled="placeholderDisabled">{{ placeholder }}</option>
        </template>
        <template v-if="options.length">
            <option
                v-for="opt in options"
                :key="opt.value"
                :value="opt.value"
                :disabled="opt.disabled"
            >
                {{ opt.text }}
            </option>
        </template>
        <slot v-else></slot>
    </select>
</template>

<script>
export default {
    name: "CarbonSelect",
    inheritAttrs: false,
    props: {
        value: {
            type: [String, Number, Array],
            default: "",
        },
        /** [{ value, text, disabled? }] - 사용 시 option 자동 렌더 */
        options: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: "",
        },
        /** placeholder 옵션 선택 불가 여부 */
        placeholderDisabled: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        customClass: {
            type: [String, Array],
            default: "",
        },
    },
    computed: {
        selectClasses() {
            const list = ["carbon-select"];
            const custom = this.customClass;
            if (custom) {
                if (Array.isArray(custom)) list.push(...custom.filter(Boolean));
                else list.push(custom);
            }
            return list;
        },
    },
    methods: {
        onChange(e) {
            const val = e.target.value;
            // placeholder(빈 값) 선택 시 그대로 "" emit → placeholder 옵션 표시 유지
            if (val === "") {
                this.$emit("input", "");
                this.$emit("change", "");
                return;
            }
            const out =
                this.options.length && this.options.some((o) => typeof o.value === "number")
                    ? Number(val)
                    : val;
            this.$emit("input", out);
            this.$emit("change", out);
        },
    },
};
</script>

<style scoped>
.carbon-select {
    padding: 6px 10px;
    border: 1px solid #cbd5e1;
    border-radius: 4px;
    font-size: 12px;
    background: #ffffff;
    color: #334155;
    min-width: 100px;
    cursor: pointer;
}

.carbon-select:focus {
    outline: none;
    border-color: #52b788;
}

.carbon-select:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}
</style>
